import axiosApiConfig from '@/axiosApiConfig';
import LPN from '@/interfaces/LPN';
import { Product } from '@/interfaces/ProductRefactor';

export async function getSearchInventory(data:{search: string, rackId: string, type: string}): Promise<any> {
  const result : any = await axiosApiConfig.get('/search_inventory', { params: { ...data } });
  if (result.status !== 200) {
    throw result.data;
  }
  return result.data;
}

export async function getSearchFolioInventory(data:{search: string, rackId: string}): Promise<Product> {
  const result : any = await axiosApiConfig.get('/search_inventory', { params: { ...data, type: 'folio' } });
  if (result.status !== 200) {
    throw result.data;
  }
  return result.data;
}

export async function getSearchLPNInventory(data:{search: string, rackId: string}): Promise<LPN> {
  const result : any = await axiosApiConfig.get('/search_inventory', { params: { ...data, type: 'lpn' } });
  if (result.status !== 200) {
    throw result.data;
  }
  return result.data;
}

export async function getSearchSKUInventory(data:{search: string, rackId: string}): Promise<Product> {
  const result : any = await axiosApiConfig.get('/search_inventory', { params: { ...data, type: 'sku' } });
  if (result.status !== 200) {
    throw result.data;
  }
  return result.data;
}


export default getSearchFolioInventory;
